import React from "react";
import classNames from 'classnames';

import { FormSectionElements } from "../../entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import { HintExpansionComponent } from "../odsCalloutBox/HintExpansionComponent";
import { getRootComponent } from "../../utilities/ElementUtils";

interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
}

interface State {
}

export class DriverLicenseComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    let field = this.props.field;
    FormValidationUtils.runJavascript(field);
  }
  
  onChange = (e) => {
    let field = this.props.field;
    let val = e.target.value;
   
    // Remove any existing dashes and spaces
    // val = val.replace(/[-\s]/g, '');
   
    // if (val) {
    //   val = val.trim();
    // }
 
    // Format with dashes after every 5 characters
    // if (val.length > 0) {
    //   const parts = [];
    //   for (let i = 0; i < val.length && i < 15; i += 5) {
    //     parts.push(val.slice(i, i + 5));
    //   }
    //   val = parts.join('-');
    // }
 
    field.Value = val;
 
    FormValidationUtils.validateDriverLicense(field);
 
    this.props.callbackElement(getRootComponent(field));
  }
  
  onBlur = (e) => {
    let field = this.props.field;

    // Remove any existing dashes and spaces
    // field.Value = field.Value.replace(/[-\s]/g, '');
   
    if (field.Value) {
      field.Value = field.Value.replace(/[-\s]/g, '').trim().toUpperCase();
    }
 
    // Format with dashes after every 5 characters
    if (field.Value.length > 0) {
      const parts = [];
      for (let i = 0; i < field.Value.length && i < 15; i += 5) {
        parts.push(field.Value.slice(i, i + 5));
      }
      field.Value = parts.join('-');
    }
 
    FormValidationUtils.evalDriversLicenseCardRegularExpression(field)
  
    if (field.Valid) {
      FormValidationUtils.runJavascript(field);
    }
    this.props.callbackElement(getRootComponent(field));
  }


  render() {
    let field = this.props.field;
    if(!field.Visible) return null;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;
    let hintHtml = this.props.isEng ? field.Hint : field.HintFR;

   const requiredLabel = this.props.field.Optional == "N" ? (this.props.isEng   ? "(required)"   : "(obligatoire)" ) : this.props.isEng ? "(optional)" : "(facultatif)"

    if (editable) {
      controlArray.push(
        <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}>
          <div key={'fdLbl_div_' + field.Id} >
            <label className="ontario-label" htmlFor={field.LoadBindName}  id={`label_${field.LoadBindName}`} key={'fdLbl_' + field.Id} >
              {title}{" "}
            <span className='ontario-label__flag'>{title ? requiredLabel : null}</span>
            {field.TooltipENU && (<i role='tooltip' title={field.TooltipENU} className="pi pi-info-circle"></i>)}
            </label>
            {hintHtml ? <p className="ontario-hint" id={`hint-text-${field.LoadBindName}`} tabIndex={field.Valid ? undefined : -1} dangerouslySetInnerHTML={{ __html: hintHtml }}></p> : null}
          </div>
            <LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}              
              key={"LiveValidationErrMsg_" +this.props.field.LoadBindName}/>
          <div key={'fdIpt_div_' + field.Id}>
            <div>
            <input className={field.Valid ||!field.Touched ? 'ontario-input ontario-input--20-char-width' : 'ontario-input ontario-input--20-char-width ontario-input__error'}
              id={field.LoadBindName}  key={'fdIpt_' + field.Id}
              maxLength={17}
              required={field.Optional !== 'Y'}
              aria-invalid={!field.Valid ||field.Touched ? true : undefined}
              aria-describedby={
                [!field.Valid && `${field.LoadBindName}-${field.Id}-error`, hintHtml && `hint-text-${field.LoadBindName}`]
                .filter(Boolean)
                .join(' ') || undefined
                }
              value={field.Value} readOnly={field.ReadOnly}
              onChange={this.onChange} onBlur={this.onBlur}/>
            </div>
          </div>
          {field.hintExpansionTitle && editable && <HintExpansionComponent
            isEng={this.props.isEng}
            calloutType={field.callOutBoxType}
            Visible={true}
            bodyMsg={this.props.isEng ? field.callOutBoxBody : field.callOutBoxBodyFRA}
            title={this.props.isEng ? field.callOutBoxTitle : field.callOutBoxTitleFRA}
            hintExpansionTitle={this.props.isEng ? field.hintExpansionTitle : field.hintExpansionTitleFRA}
            field={field}/>}
        </div>);
    } else {
      controlArray.push(
        <div className={classNames('pdf-two-column', { 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })}>
          <div>{title}</div>
          <div> {field.Value}</div>
        </div>
      );
    }
    return controlArray;
  }
}